import React, { Component }  from 'react';
import './sai.css'
 export default function Sai(){


    return  <div className="s-heart"></div>

    
 }